import {Component, Input, OnInit} from '@angular/core';
import {Food} from './food';


@Component({
  selector: 'app-food',
  templateUrl: './food.component.html',
  styleUrls: ['./food.component.css']
})
export class FoodComponent implements OnInit {

  @Input() food: Food;
  @Input() size = 10;

  constructor() { }

  ngOnInit(): void {
  }

  get style(): any {
    return {
      top: `${this.food.y * this.size}px`,
      left: `${this.food.x * this.size}px`,
      width: `${this.size}px`,
      height: `${this.size}px`,
    };
  }

  get foodClass(): string {
    return this.food.type;
  }
}
